





import { Component, Prop, Vue } from "vue-property-decorator";
import { EVisitorReportTypeEnum } from "../EVisitorReportDialog.vue";
@Component({
  components: {},
})
export default class ETurizemReportForm extends Vue {
  @Prop({ default: null }) dateFrom?: Date;
  @Prop({ default: null }) dateTo?: Date;
  @Prop({ default: () => EVisitorReportTypeEnum.Monthly })
  reportType?: EVisitorReportTypeEnum;

  submit() {
    if (this.dateFrom && this.dateTo && this.reportType) {
      this.$emit(
        "submit",
        { dateFrom: this.dateFrom, dateTo: this.dateTo },
        "blob"
      );
    }
  }
}
